import {
  Breadcrumb,
  StyledBreadcrumbItem,
  breadcrumbStyles,
  breadcrumbDividerStyles,
} from './Breadcrumb'

export { breadcrumbStyles, breadcrumbDividerStyles }
export default Object.assign(Breadcrumb, { Item: StyledBreadcrumbItem })
